import { useForm } from "react-hook-form";
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import { useIntlWrapperContext } from "../../Helpers/IntlWrapperProvider";
import useFetchWrapper from "../../Helpers/useFetchWrapper";
import { AdminInvite, InvitationType, Props, Role, UserInvite } from "./InviteUser.model";

export const useInviteUser = ({onClose}: Props) => {
  const { post } = useFetchWrapper();
  const { i18nCountries } = useIntlWrapperContext();

  const { control, formState: { errors }, handleSubmit, watch } = useForm({
		defaultValues: {
			email: '',
			firstName: '',
			invitationType: InvitationType.Admin,
      lastName: '',
			location: undefined,
			role: Role.Mentor,
    }
	});
	
	const invitationType = watch('invitationType');

	const sendInvitation = async (data: AdminInvite | UserInvite) => {
		const url = invitationType === InvitationType.Admin ? '/user/admin/invite' : '/user/invite'
    await post(url, data);
		onClose();
  }

  return {
    control,
    errors,
    handleSubmit,
    i18nCountries,
		sendInvitation,
		state: {
			invitationType
		}
  }
}